"use client";

import React from "react";
import {Locale} from "~/i18n-config";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ClientLocaleProvider} from "~/components/providers/client/LocaleProvider";
import {ClientAuthProvider} from "~/components/providers/client/AuthProvider";
import {ClientAccountProvider} from "~/components/providers/client/AccountProvider";
import {ClientMeetingProvider} from "~/components/providers/client/MeetingProvider";
import {ClientAnalyticsProvider} from "@/components/providers/client/AnalyticsProvider";

export function ClientProviders(props: {
    locale: Locale,
    dictionary: any,
    children: React.ReactNode,
}) {
    const [queryClient] = React.useState(() => new QueryClient())
    return (
        <QueryClientProvider client={queryClient}>
            <ClientLocaleProvider locale={props.locale}>
                <ClientAuthProvider>
                    <ClientAccountProvider>
                        <ClientAnalyticsProvider dictionary={props.dictionary}>
                            <ClientMeetingProvider>
                                {props.children}
                            </ClientMeetingProvider>
                        </ClientAnalyticsProvider>
                    </ClientAccountProvider>
                </ClientAuthProvider>
            </ClientLocaleProvider>
        </QueryClientProvider>
    );
}
